import * as React from "react";

function AlertCircle(props) {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 24c0 12.15 9.85 22 22 22s22-9.85 22-22S36.15 2 24 2 2 11.85 2 24zm40 0c0 9.941-8.059 18-18 18S6 33.941 6 24 14.059 6 24 6s18 8.059 18 18zM24 35.997a2 2 0 10.001-4 2 2 0 000 4zm2.007-24h-4.001v16h4.001v-16z"
      />
    </svg>
  );
}

export default AlertCircle;
